import React from 'react'
import '../styles/what-we-do.css'
import CardSlider from '../components/CardSlider.jsx'




function WhatWeDo() {

  return (
    <div className='what-we-do-container'>
        <div className="what-we-do-text">
            <h2>What we do</h2> 
            <p>At Nextcastle Energy Limited, we provide comprehensive oilfield services designed to support the upstream, midstream, and downstream sectors of the oil and gas industry. Our expertise spans across engineering, fabrication, construction, equipment supply, and operational support, ensuring seamless project execution with a commitment to quality, safety, and efficiency.</p>
        </div>
        
        <CardSlider/>
    </div>
  )
}

export default WhatWeDo